import { CompaniesNames } from '../Constants'
import { ClickNewAddressInstruction } from './Instructions/ClickButtonInstructions/ClickNewAddressInstruction'
import { ClickSaveAddressInstruction } from './Instructions/ClickButtonInstructions/ClickSaveAddressInstruction'
import { SaveInAddressBookInstruction } from './Instructions/ClickInputInstructions/SaveInAddressBookInstruction'
import { FillInputByLabelInstruction } from './Instructions/FillInputByLabelInstruction'
import { ExtraAddressInfoInstruction } from './Instructions/FillInputByLabelInstructions/ExtraAddressInfo'
import { FirstnameInstruction } from './Instructions/FillInputByNameInstructions/FirstnameInstruction'
import { LastnameInstruction } from './Instructions/FillInputByNameInstructions/LastnameInstruction'
import { PhoneInstruction } from './Instructions/FillInputByNameInstructions/PhoneInstruction'
import {
  RutFillTypes,
  RutInstruction
} from './Instructions/FillInputByLabelInstructions/RutInstruction'
import { StreetInstruction } from './Instructions/FillInputByLabelInstructions/StreetInstruction'
import { StreetNumberInstruction } from './Instructions/FillInputByLabelInstructions/StreetNumberInstruction'
import { DistrictInstruction } from './Instructions/SelectInstructions/DistrictInstruction'
import { RegionInstruction } from './Instructions/SelectInstructions/RegionInstruction'
import { ShippingMethodInstruction } from './Instructions/ShippingMethodInstruction'
import { PaymentMethodInstruction } from './Instructions/PaymentMethodInstruction'
import { ClickPlaceOrderInstruction } from './Instructions/ClickButtonInstructions/ClickPlaceOrderInstruction'
import { EmailInstruction } from './Instructions/FillInputByLabelInstructions/EmailInstructions'
import { CorporateRutInstruction } from './Instructions/FillInputByLabelInstructions/CorporateRutInstruction'
import { CorporateEmailInstruction } from './Instructions/FillInputByLabelInstructions/CorporateEmailInstruction'
import { CorporateNameInstruction } from './Instructions/FillInputByLabelInstructions/CorporateNameInstruction'
import { CorporateCategoryInstruction } from './Instructions/FillInputByLabelInstructions/CorporateCategoryInstruction'
import { FullAddressInstruction } from './Instructions/FillInputByLabelInstructions/FullAddressInstruction'
import { SelectOptionInstruction } from './Instructions/SelectOptionInstruction'
import { TextDistrictInstruction } from './Instructions/FillInputByLabelInstructions/TextDistrictInstruction'
import { ZipCodeInstruction } from './Instructions/FillInputByLabelInstructions/ZipCodeInstruction'
import { ClickNextInstruction } from './Instructions/ClickButtonInstructions/ClickNextInstruction'
import { SameBillingAndShippingAddressInstructionInstruction } from './Instructions/ClickInputInstructions/SameBillingAndShippingAddressInstruction'
import { ClickInputInstruction } from './Instructions/ClickInputInstruction'

export class CompanyInstructionsFactory {
  constructor (params, companyName, isUserLoggedIn, needsBilling) {
    this.params = params
    this.isUserLoggedIn = isUserLoggedIn
    this.needsBilling = needsBilling
    this.currentId = 0
    this.companyName = companyName
    this.instructions = []
  }

  getHeadInstructions = (isUserLoggedIn, needsBilling) => [
    ...(isUserLoggedIn
      ? [new ClickNewAddressInstruction({})]
      : [new EmailInstruction({ waitForNoLoaders: true })]),
    new FirstnameInstruction({ value: '', name: 'EmptyFirstname' }),
    new LastnameInstruction({}),
    new PhoneInstruction({}),
    new RutInstruction({ label: 'Rut', rutType: RutFillTypes.OnlyNumbers }),
    new StreetInstruction({ label: 'Calle' }),
    new StreetNumberInstruction({ label: 'Número' }),
    new ExtraAddressInfoInstruction({ label: 'Dpto/Block/Piso' }),
    new RegionInstruction({ label: 'Región' }),
    new DistrictInstruction({ label: 'Comuna' }),
    new FirstnameInstruction({}),
    new FillInputByLabelInstruction({
      name: 'Birthdate',
      label: 'Fecha de Nacimiento',
      value: '01/01/1990',
      waitForNoLoaders: true
    }),
    ...(isUserLoggedIn
      ? [
          new SaveInAddressBookInstruction({
            label: 'Guardar en libreta de direcciones'
          }),
          new ClickSaveAddressInstruction({})
        ]
      : []),
    ...(needsBilling
      ? [
          new ClickInputInstruction({
            name: 'BillingCheckbox',
            label: 'Factura'
          }),
          new CorporateRutInstruction({ label: 'Rut Empresa' }),
          new CorporateEmailInstruction({ label: 'Email Facturación' }),
          new CorporateNameInstruction({ label: 'Razón Social' }),
          new CorporateCategoryInstruction({ label: 'Giro' })
        ]
      : []),
    new ShippingMethodInstruction({}),
    new PaymentMethodInstruction({}),
    new ClickPlaceOrderInstruction({})
  ]

  getVitelInstructions = (isUserLoggedIn, needsBilling) => [
    ...(isUserLoggedIn
      ? [new ClickNewAddressInstruction({})]
      : [new EmailInstruction({})]),
    new FirstnameInstruction({}),
    new LastnameInstruction({}),
    new PhoneInstruction({}),
    new RutInstruction({ label: 'RUT', rutType: RutFillTypes.OnlyNumbers }),
    new FullAddressInstruction({ label: 'Dirección (calle, N° de casa)' }),
    new ExtraAddressInfoInstruction({ label: 'Office, House, Apartment' }),
    new RegionInstruction({ label: 'Región' }),
    new DistrictInstruction({ label: 'Comuna' }),
    ...(isUserLoggedIn
      ? [
          new SaveInAddressBookInstruction({
            label: 'Guardar en libreta de direcciones'
          }),
          new ClickSaveAddressInstruction({})
        ]
      : []),
    ...(needsBilling
      ? [
          new SelectOptionInstruction({
            name: 'Need Invoice',
            label: 'Desea Factura',
            value: 'Si'
          })
        ]
      : []),
    new ShippingMethodInstruction({}),
    new PaymentMethodInstruction({}),
    new ClickPlaceOrderInstruction({})
  ]

  getDefaultInstructions = (isUserLoggedIn) => [
    ...(isUserLoggedIn
      ? [new ClickNewAddressInstruction({})]
      : [new EmailInstruction({})]),
    new FullAddressInstruction({ label: 'Street Address' }),
    new RegionInstruction({ label: 'State/Province' }),
    new TextDistrictInstruction({ label: 'City' }),
    new ZipCodeInstruction({ label: 'Zip/Postal Code' }),
    new FirstnameInstruction({}),
    new LastnameInstruction({}),
    new PhoneInstruction({}),
    ...(isUserLoggedIn
      ? [
          new SaveInAddressBookInstruction({ label: 'Save in address book' }),
          new ClickSaveAddressInstruction({})
        ]
      : []),
    new ShippingMethodInstruction({}),
    new ClickNextInstruction({}),
    ...(isUserLoggedIn
      ? [new SameBillingAndShippingAddressInstructionInstruction({})]
      : []),
    new PaymentMethodInstruction({}),
    new ClickPlaceOrderInstruction({})
  ]

  getCompanyInstructions () {
    const instructionsByCompany = {
      [CompaniesNames.Head]: this.getHeadInstructions(
        this.isUserLoggedIn,
        this.needsBilling
      ),
      [CompaniesNames.Vitel]: this.getVitelInstructions(
        this.isUserLoggedIn,
        this.needsBilling
      )
    }
    return (
      instructionsByCompany[this.companyName] ||
      this.getDefaultInstructions(this.isUserLoggedIn)
    )
  }

  createInstructions () {
    this.instructions = this.getCompanyInstructions()
    this.prepareInstructions()
  }

  prepareInstructions () {
    this.instructions.forEach((instruction, index) => {
      instruction.prepareInstruction(index, this.params)
    })
  }

  getParsedInstructions () {
    return this.instructions.map((instruction) =>
      instruction.getParsedInstruction()
    )
  }
}
